module.exports = __webpack_public_path__ + "media/images/lb/631-be0892ebf19388772f24922b88708d77.svg";